<div class="text-right read-more-container">
  <button class="mat-outline-button gray-border extra-padding uppercase" *ngIf="field?.length > length" mat-stroked-button (click)="openModal()">
    {{ 'GENERAL.GENERIC_BUTTONS.READ_MORE' | translate }}
  </button>
</div>
